<template>
  <div class="form-step-2">
    <div class="section-subtitle">Подтверждение номера</div>
    <form class="auth-form">
      <div class="auth-form--wrap">
        <div class="input-label">Введите код из СМС сообщения</div>
        <v-otp-input
          length="5"
          type="number"
          class="four-number dark-border"
          v-model="code"
          @finish="CheckCode"
          :disabled="loading || !!token"
        />
      </div>
      <v-btn
        class="w-100 btn-blue"
        color="primary"
        :disabled="!token || loading"
        @click="$emit('submit', token)"
      >Продолжить</v-btn>
    </form>
  </div>
</template>

<script>
export default {
  name: 'FormStep2',
  props: ['form'],
  data() {
    return {
      code: '',
      token: '',
      loading: false,
    };
  },
  methods: {
    /** Проверка кода полученного в СМС */
    CheckCode() {
      const app = this;
      const url = 'api/token/check-sms';
      const { type, phone } = app.$props.form;
      const data = { type, code: app.code, phone };

      app.loading = true;
      app.$store.getters.axl.post(url, data)
        .then((response) => {
          app.token = response.data.token;
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => { app.loading = false; });
    },
  },
  mounted() {
  },
};
</script>
